module.exports = __webpack_public_path__ + "static/media/julles.dcfb8cb4.jpg";